exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gmapwrap[data-v-e587b2fe]{max-width:600px;width:100%;height:450px;max-height:100vw}.gmapsize[data-v-e587b2fe]{border:0;width:100%;height:100%}.lab-photo[data-v-e587b2fe]{max-width:100%;max-height:250px;padding:0 20px;margin-bottom:-30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e587b2fe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ContactInfo.vue
// module id = 180
// module chunks = 0